import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  const loc = useLocation();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--tt-muted)] text-sm uppercase tracking-[0.2em]">
        Checking session…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
}
